const MsLogo = () => (
  <svg width="23" height="24" viewBox="0 0 23 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1850_17568)">
      <path d="M0 0.834961H23V23.835H0V0.834961Z" fill="#F3F3F3" />
      <path d="M1 1.83496H11V11.835H1V1.83496Z" fill="#F35325" />
      <path d="M12 1.83496H22V11.835H12V1.83496Z" fill="#81BC06" />
      <path d="M1 12.835H11V22.835H1V12.835Z" fill="#05A6F0" />
      <path d="M12 12.835H22V22.835H12V12.835Z" fill="#FFBA08" />
    </g>
    <defs>
      <clipPath id="clip0_1850_17568">
        <rect width="23" height="23" fill="white" transform="translate(0 0.834961)" />
      </clipPath>
    </defs>
  </svg>
);

export default MsLogo;
